var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Cargando...")]):[_c('div',{class:['line', _vm.currentStep >= 0 ? 'line-green' : 'line-gray']}),_vm._l((_vm.timelinePoints),function(point,index){return _c('div',{key:index,staticClass:"point-wrap"},[_c('div',{staticClass:"tooltip-wrapper"},[_c('button',{staticClass:"dot",class:[
            _vm.currentStep === -1
              ? 'dot-gray'
              : point.esCalculado
              ? // Para punto calculado, mostrar verde si tiene tiempo estimado
                point.time
                ? 'dot-green'
                : 'dot-gray'
              : index < _vm.currentStep
              ? 'dot-green'
              : index === _vm.currentStep
              ? 'dot-orange'
              : 'dot-blue' ],attrs:{"aria-label":((point.label) + ": " + (point.esCalculado
              ? point.time || 'Sin datos'
              : _vm.formatTime(point.time)))}}),_c('div',{staticClass:"tooltip-content"},[_c('div',{staticClass:"tooltip-title"},[_vm._v(_vm._s(point.label))]),_c('div',{staticClass:"tooltip-date",class:[
              _vm.currentStep === -1
                ? 'tooltip-date-gray'
                : point.esCalculado
                ? // Para punto calculado
                  point.time
                  ? 'tooltip-date-green'
                  : 'tooltip-date-gray'
                : point.fechahora
                ? 'tooltip-date-green'
                : 'tooltip-date-orange' ]},[_vm._v(" "+_vm._s(_vm.currentStep === -1 ? "Sin notificaciones" : point.esCalculado ? point.time ? ("Tiempo estimado: " + (point.time)) : "Faltan datos de asignación o llegada" : point.fechahora ? _vm.formatDateTime(point.fechahora) : "Pendiente")+" ")])])]),_c('div',{class:[
          'line',
          _vm.currentStep === -1
            ? 'line-gray'
            : point.esCalculado
            ? // Para línea después del punto calculado
              // Verde si llegada está completada (currentStep >= 2)
              _vm.currentStep >= 2
              ? 'line-green'
              : 'line-gray'
            : index < _vm.currentStep
            ? 'line-green'
            : 'line-gray' ]})])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }